import { Component } from "vue-property-decorator"

import SearchBase from "./search.client.base"

@Component
export default class SearchWeb extends SearchBase {}
